import { render, staticRenderFns } from "./myOrderPage.vue?vue&type=template&id=60ff477a&scoped=true"
import script from "./myOrderPage.vue?vue&type=script&lang=js"
export * from "./myOrderPage.vue?vue&type=script&lang=js"
import style0 from "./myOrderPage.vue?vue&type=style&index=0&id=60ff477a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ff477a",
  null
  
)

export default component.exports